export default __webpack_public_path__ + "_/shared_modules/continue-app/images/rejected-borrower-76224abcc119b3ea61c713e12e537460.svg";